import React from "react";
import "./Card.css";

const Card = (props) => {
  return <div className={props.styleProps}>{props.children}</div>;
};

export default Card;



// WEBPACK FOOTER //
// ./src/components/UI/Card/Card.jsx